@if (openNavBar) {
  <div
    id="wbce-sidenav"
    [@fadeInOut]
    [ngClass]="integrated ? 'integrated' : ''"
    >
    <ng-content></ng-content>
  </div>
}
